import React, { createContext } from 'react'

const DeviceContext = createContext<app.Device>({
  isAndroid: false,
  isIOS: false,
  isMacOS: false,
  isWindows: false,
  browser: '',
  isNativeApp: false,
  isMobile: false,
  language: 'pl'
})

interface DeviceProviderProps {
  deviceInfo: app.Device
  children: React.ReactNode
}

const DeviceProvider: React.FC<DeviceProviderProps> = ({ children, deviceInfo }) => {
  return (
    <DeviceContext.Provider value={deviceInfo}>
      {children}
    </DeviceContext.Provider>
  )
}

export default DeviceProvider
export {
  DeviceContext
}
